(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('InvoiceInfoDialogV2Controller', InvoiceInfoDialogV2Controller);

    InvoiceInfoDialogV2Controller.$inject = ['$state', '$timeout', '$scope', 'entity', '$stateParams', 'OrderBag', 'OrderBagCustom', 'ServiceItemCustom', 'ServiceTimeSessionInfoCustom', 'ServiceTimeSession', 'CustomerCustom', 'Customer', 'Principal', '$uibModal', '$rootScope', 'InvoiceInfo', 'ServantCustom', 'SettingInfoCustom'];

    function InvoiceInfoDialogV2Controller($state, $timeout, $scope, entity, $stateParams, OrderBag, OrderBagCustom, ServiceItemCustom, ServiceTimeSessionInfoCustom, ServiceTimeSession, CustomerCustom, Customer, Principal, $uibModal, $rootScope, InvoiceInfo, ServantCustom, SettingInfoCustom) {

        var vm = this;
        vm.invoiceInfo = entity;
        vm.clear = clear;
        vm.save = save;

        vm.newCustomerPopUp = newCustomerPopUp;
        vm.customerMode = "find";
        vm.findCustomerKeyPress = findCustomerKeyPress;
        vm.newInvoiceInfoItem = newInvoiceInfoItem;
        vm.onItemFieldChanged = onItemFieldChanged;
        vm.deleteItem = deleteItem;
        vm.invoiceItemListEmptyMessage = 'هیچ آیتمی انتخاب نشده است';

        vm.closeModal = closeModal;
        vm.okModal = okModal;
        vm.searchCustomerByPhoneNumber = searchCustomerByPhoneNumber;
        vm.taxPercentage = 0;

        $rootScope.$broadcast('hideNavBar');


        load();

        function load() {

            if (vm.invoiceInfo.id)
                loadAvailableServants();

            getCompanyFinancialSetting();
        }

        function getCompanyFinancialSetting() {
            vm.companySetting = SettingInfoCustom.getSettingInfoByCurrentCompany().query(function (data) {
                vm.taxPercentage = data.financialSetting.taxPercentage;
            });
        }

        function clear() {
        }

        function save() {
            vm.isSaving = true;
            if (vm.invoiceInfo.id !== null) {
                InvoiceInfo.update(vm.invoiceInfo, onSaveSuccess, onSaveError);
            } else {
                InvoiceInfo.save(vm.invoiceInfo, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:invoiceInfoUpdate', result);

            vm.isSaving = false;

            if (result.status != 'TEMP')
                $state.transitionTo('supplierPanel-v2.invoiceInfoDetail', {id: result.id});
        }

        function onSaveError() {
            vm.isSaving = false;
        }


        function newCustomerPopUp() {
            $rootScope.modalInstance = $uibModal.open({
                templateUrl: 'app/entities/company-customer/company-customer-modal.html',
                controller: 'CompanyCustomerModalController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                windowClass: 'pl-modal',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        // $translatePartialLoader.addPart('company');
                        $translatePartialLoader.addPart('personInfo');
                        // $translatePartialLoader.addPart('serviceItem');
                        // $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    entity: function () {

                        return {
                            // title: null,
                            // level: null,

                            id: null
                        };
                    }
                }
            });

            $rootScope.modalInstance.result.then(function (v) {

                vm.invoiceInfo.customer = v.customer;
                //reload();
            }, function () {
                //nothing
            });
        }

        function findCustomerKeyPress(e) {
            if (e.keyCode === 13) {
                findCustomer();
                e.preventDefault();
                return false;
            }
            return true;
        }

        function findCustomerById(id) {
            return Customer.get({id: id}).$promise;
        }


        function closeModal() {
            $rootScope.$broadcast('showNavBar');
            if ($state.current.parent == 'supplierPanel-v2.dashboard') {
                $state.go('supplierPanel-v2.dashboard');
                return;
            }

            if ($rootScope.fromState && $rootScope.fromState.name) {

                if ($rootScope.fromState.name == 'supplierPanel-v2.invoiceInfoList'
                    || $rootScope.fromState.name == 'supplierPanel-v2.editInvoiceInfo'
                    || $rootScope.fromState.name == 'supplierPanel-v2.invoiceInfoDetail'
                    || $rootScope.fromState.name == 'supplierPanel-v2.editInvoiceInfo.delete') {
                        $state.go('supplierPanel-v2.invoiceInfoList', $rootScope.fromStateParams);
                    return;
                } else {

                    if ($rootScope.fromStateParams) {
                        $state.go($rootScope.fromState.name, {id: $rootScope.fromStateParams.id});
                        return;
                    } else {
                        $state.go($rootScope.fromState.name);
                        return;
                    }

                }
            }

            $state.go('supplierPanel-v2.invoiceInfoList');

        }

        function okModal() {
            save();

        }


        function searchCustomerByPhoneNumber() {

            if (!vm.orderBag.customer.personalInfo.phoneNumber || vm.orderBag.customer.personalInfo.phoneNumber.length < 6 || vm.orderBag.customer.personalInfo.phoneNumber.length == 11) {
                vm.existCustomerSearchResult = [];
                return;
            }

            CustomerCustom.searchCustomerBySearch(vm.orderBag.customer.personalInfo.phoneNumber).query().$promise.then(function (result) {
                vm.existCustomerSearchResult = result;
            });

        }

        function newInvoiceInfoItem() {
            $rootScope.modalInstance = $uibModal.open({
                templateUrl: 'app/entities/invoice-info/add-invoice-item-modal.html',
                controller: 'AddInvoiceItemModalController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                windowClass: 'pl-modal',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        // $translatePartialLoader.addPart('company');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('serviceItem');
                        // $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            });

            $rootScope.modalInstance.result.then(function (items) {

                addItemsToInvoice(items);
                //reload();
            }, function () {
                //nothing
            });
        }

        function addItemsToInvoice(items) {

            if (!vm.invoiceInfo.invoiceInfoItems)
                vm.invoiceInfo.invoiceInfoItems = [];
            angular.forEach(items, function (item) {
                vm.invoiceInfo.invoiceInfoItems.push(item);
            })
        }

        function loadAvailableServants() {
            if (!vm.invoiceInfo || !vm.invoiceInfo.id)
                return;


            angular.forEach(vm.invoiceInfo.invoiceInfoItems, function (item) {
                if (item.type == 'SERVICE' && item.referencedItemId)
                    getAvailableServantForServiceItem(item);
                else
                    getAllActiveServants(item);
            })

        }

        function getAvailableServantForServiceItem(invoiceInfoItem) {

            if (invoiceInfoItem.referencedItemId) {
                ServiceItemCustom.getServiceServants(invoiceInfoItem.referencedItemId).query(function (servants) {

                    if (servants && servants.length > 0) {
                        invoiceInfoItem.availableServants = servants;
                        angular.forEach(servants, function (srv) {
                            if (srv.id == invoiceInfoItem.servant.id)
                                invoiceInfoItem.servant = srv;
                        })

                    }
                });
            }
        }

        function getAllActiveServants(invoiceInfoItem) {

            if (vm.allServants) {
                invoiceInfoItem.availableServants = vm.allServants;
                angular.forEach(vm.allServants, function (srv) {
                    if (srv.id == invoiceInfoItem.servant.id)
                        invoiceInfoItem.servant = srv;
                })
            } else {
                ServantCustom.findServantsByCompany().query(function (list) {
                    vm.allServants = list;
                    getAllActiveServants(invoiceInfoItem);
                })
            }


        }

        function computeFinalPrice() {

            vm.invoiceInfo.totalServicePrice = 0;
            vm.invoiceInfo.totalProductPrice = 0;
            vm.invoiceInfo.totalOptionPrice = 0;
            vm.invoiceInfo.totalVat = 0;
            if (vm.invoiceInfo.totalDiscount == undefined)
                vm.invoiceInfo.totalDiscount = 0;
            vm.invoiceInfo.finalPrice = 0;


            if (!vm.invoiceInfo.invoiceInfoItems)
                return;


            angular.forEach(vm.invoiceInfo.invoiceInfoItems, function (item) {

                if (item.type == 'SERVICE')
                    vm.invoiceInfo.totalServicePrice += item.price * item.qty;
                if (item.type == 'PRODUCT')
                    vm.invoiceInfo.totalProductPrice += item.price * item.qty;
                if (item.type == 'SERVICE_ADD_ON' || item.type == 'SERVICE_OPTION')
                    vm.invoiceInfo.totalOptionPrice += item.price * item.qty;

            })


            vm.invoiceInfo.finalPrice = vm.invoiceInfo.totalServicePrice + vm.invoiceInfo.totalProductPrice + vm.invoiceInfo.totalOptionPrice - vm.invoiceInfo.totalDiscount

            //MUST GET VAT FROM SETTING!!!!!!!!!!!!!!
            vm.invoiceInfo.totalVat = vm.invoiceInfo.finalPrice * vm.taxPercentage / 100;
            vm.invoiceInfo.finalPrice = vm.invoiceInfo.finalPrice + vm.invoiceInfo.totalVat;

        }

        function onItemFieldChanged() {
            computeFinalPrice();
        }

        function deleteItem(item) {
            vm.invoiceInfo.invoiceInfoItems = vm.invoiceInfo.invoiceInfoItems.filter(function (invoiceItem) {


                if (
                    (invoiceItem.id && item.id && invoiceItem.id == item.id)
                    ||
                    (invoiceItem.randomNo && item.randomNo && invoiceItem.randomNo == item.randomNo)) {
                    //nothing
                } else {
                    return invoiceItem;
                }

            })

            computeFinalPrice();
        }

        $scope.$watch('vm.invoiceInfo', function () {
            computeFinalPrice();
        })


    }
})();
